import './index.css'
import React, { useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { Grid, GridColumn as Column } from '@progress/kendo-react-grid'
import LoadingOverlay from 'components/Common/Overlay/LoadingOverlay'
import ConfirmDialog from 'components/Common/Dialog/ConfirmDialog'
import removeImg from 'assets/vault icons/deleteIcon.svg'
import ButtonTooltip from 'components/Common/ToolTip/ButtonTooltip'
import actionTypes from 'store/actions'
import { Box } from '@mui/material'

const VaultBOTable = () => {
  const dispatch = useDispatch()

  const [showRemoveConfirmPopup, setShowRemoveConfirmPopup] = useState(false)
  const [selectedToRemove, setSelectedToRemove] = useState(null)
  const [fetchStatus] = useState(false)

  const draftBOs = useSelector(state => state.vaultReducer.draftBOs)

  const onRemoveBO = boId => {
    setSelectedToRemove(boId)
    setShowRemoveConfirmPopup(true)
  }

  const removeDocument = () => {
    dispatch({ type: actionTypes.VAULTREMOVEDRAFTBO, payload: { id: selectedToRemove } })
    setShowRemoveConfirmPopup(false)
  }

  return (
    <Box>
    <div className="vault-bo-add-table-wrapper">
      {fetchStatus && (
        <LoadingOverlay
          style={{
            height: 'calc(100% - 1rem)',
            width: 'calc(100% - 2rem)',
            fontSize: '3rem',
          }}
        />
      )}
      <Grid
        style={{
          // maxHeight: '30px',
          minHeight: '35px',
          minWidth: '750px',
        }}
        data={draftBOs}
      >
        <Column
          field="ownerType"
          headerCell={() => <span className="color-primary">Owner type</span>}
          width="140px"
          cell={props => <td {...props}>{props.dataItem[props.field] === 'B' ? 'Business' : 'Individual'}</td>}
        />
        <Column field="displayName" headerCell={() => <span className="color-primary">Name</span>} width="200px" />
        <Column field="email" headerCell={() => <span className="color-primary">Email</span>} width="220px" />
        {/* <Column field="status" headerCell={() => <span className="color-primary">Status</span>} width="120px" /> */}
        <Column
          field=""
          headerCell={() => <span></span>}
          width="36px"
          cell={props => (
            <ButtonTooltip placement={'top'} title={'Delete'} arrow onClick={() => onRemoveBO(props.dataItem['id'])}>
              <img src={removeImg} height="15" width="13" alt={'delete-button'} style={{ cursor: 'pointer' }} />
            </ButtonTooltip>
          )}
        />
      </Grid>
      {showRemoveConfirmPopup && (
        <ConfirmDialog
          show={showRemoveConfirmPopup}
          setShow={() => setShowRemoveConfirmPopup(false)}
          onSuccess={removeDocument}
          SuccessMessage="Remove"
          title="Are You Sure?"
          content="Do you want to proceed with removing this beneficial owner from the draft?"
        />
      )}
    </div>
    </Box>
  )
}

export default VaultBOTable
